import type { ListItem } from "../../components/List/List"
import { AdminEmployee } from "../AdminEmployee/AdminEmployee"
import { MemoryClass } from "./MemoryClass"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { ShieldCheck, Mail, Circle } from "lucide-react"
import { DEFAULT_ADMIN_AVATAR } from "../../utils/employeeAvatar"

export class AdminEmployeeMemory extends MemoryClass<AdminEmployee> {
  setList = (list: AdminEmployee[]) => {
    this.listData = list
  }

  protected cloneEntity(item: AdminEmployee): AdminEmployee {
    return new AdminEmployee({ ...item })
  }

  protected getItemId(item: AdminEmployee): number {
    return item.adminEmployeeId
  }

  getListCards = (all: boolean): ListItem[] => {
    const cards: ListItem[] = []

    let count = 0

    this.listData.forEach((employee) => {
      if (all || employee.status === EEnableStatusType.Active) {
        cards.push(this.getCard(employee, count))

        count++
      }
    })

    return cards
  }

  getCard(employee: AdminEmployee, count: number): ListItem {
    const enable = employee.status === EEnableStatusType.Active

    return {
      isDisable: !enable,
      id: employee.adminEmployeeId,
      title: employee.name,
      linkImage: DEFAULT_ADMIN_AVATAR,
      index: count,
      dataFilter: [employee.username, employee.email, employee.status.toEnableStatusTypeString()],
      children: (
        <div className={`flex justify-between gap-4 p-3 ${enable ? "bg-white" : "bg-gray-50 opacity-70"}`}>
          <div className="flex flex-col flex-1">
            <div className="flex items-center gap-2">
              {employee.isRoot && (
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-amber-400 to-orange-500">
                  <ShieldCheck className="w-4 h-4 text-white" />
                </div>
              )}

              <span className="text-base font-semibold text-gray-800">{employee.name}</span>
            </div>

            <span className="mt-1 text-sm flex items-center gap-1.5 text-gray-500">
              <Mail className="w-3.5 h-3.5 text-amber-500" />

              {employee.email || employee.username}
            </span>
          </div>

          <div className="flex flex-col items-end justify-between">
            <span
              className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${
                enable
                  ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                  : "border-gray-200 bg-gray-100 text-gray-500"
              }`}
            >
              <Circle className={`w-3 h-3 ${enable ? "fill-emerald-500 text-emerald-500" : "fill-gray-400 text-gray-400"}`} />

              {employee.status.toEnableStatusTypeString()}
            </span>
          </div>
        </div>
      ),
    }
  }
}
